// Browser-safe CBDC adapter using localStorage; avoids Node fs/path

export type Settlement = { id: string; companyId: string; amountEUR: number; purposeCode: string; referenceId: string; timestamp: string };

const LS_KEY = 'evat:cbdc';

function load(): { wallets: Record<string,string>; settlements: Settlement[] } {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(LS_KEY) : null;
    return raw ? (JSON.parse(raw) as any) : { wallets: {}, settlements: [] };
  } catch { return { wallets: {}, settlements: [] }; }
}

function save(db: { wallets: Record<string,string>; settlements: Settlement[] }) {
  try { if (typeof window !== 'undefined') window.localStorage.setItem(LS_KEY, JSON.stringify(db)); } catch {}
}

export async function listCBDCBanks(): Promise<Array<{ id: string; name: string }>> {
  return [ { id: 'eu-cbdc', name: 'EU CBDC (Mock)' }, { id: 'ecb-demo', name: 'ECB Settlement Demo' } ];
}

export async function createCBDCWallet(companyId: string): Promise<{ walletId: string }>{
  const db = load();
  const walletId = db.wallets[companyId] || `cbdc-${companyId}-${Math.random().toString(36).slice(2,8)}`;
  db.wallets[companyId] = walletId; save(db);
  return { walletId };
}

export async function requestSettlement(companyId: string, amountEUR: number, purposeCode: string, referenceId: string): Promise<Settlement> {
  const db = load(); if (!db.wallets[companyId]) await createCBDCWallet(companyId);
  const rec: Settlement = { id: `stl-${Date.now()}`, companyId, amountEUR, purposeCode, referenceId, timestamp: new Date().toISOString() };
  db.settlements.push(rec); save(db);
  return rec;
}

export async function listSettlements(companyId?: string): Promise<Settlement[]> {
  const db = load();
  return (db.settlements || []).filter(s => !companyId || s.companyId === companyId).sort((a,b)=> (a.timestamp<b.timestamp?1:-1));
}



